export default {
  app: {
    title: 'LYLUP',
    admin: 'Admin Panel'
  },
  validation: {
    required: 'This field is required.',
    endDateAfterStartDate: 'End date must be after the start date.',
    invalidImageUuid: 'Invalid image ID.',
  },
  navigation: {
    dashboard: 'Dashboard',
    establishments: 'Establishments',
    locations: 'Locations',
    complexes: 'Complexes',
    menus: 'Offer',
    news: 'News',
    customers: 'Customers',
    promo: 'Promo codes',
    membership: 'Memberships',
    rewards: 'Rewards',
    admins: 'Administrators',
    employees: 'Employees',
    logout: 'Logout',
    project: 'Project',
    loadingProjects: 'Loading projects…',
    selectProject: 'Select project',
    createProject: 'Create project',
    projectName: 'Project name',
    manageProjects: 'Manage projects',
    noProjects: 'No projects available',
    noProjectsHint: 'Create your first project in Project management.',
    projectRequiredSidebarTitle: 'No projects yet — add a project first.',
    navLockedUntilProject: 'Available after you create at least one project (Administrators → Projects).',
    onboardingNavHint: 'System setup: create a project first, then use the other modules.',
    noProjectMembershipTitle: 'No project access has been assigned',
    noProjectMembershipMessage: 'Please contact your administrator to request assignment to a project. System modules are not available until access has been granted.',
    noProjectMembershipNavHint: 'The menu is unavailable until you have been assigned to at least one project.',
    viewerModeBanner: 'Read-only mode — you have viewer access on this project; creating and editing are not available.',
    viewerActionDisabledHint: 'You do not have permission for this action — your project role is view-only.',
    licenseInvalidTitle: 'License required',
    licenseInvalidMessage: 'Your license is missing or no longer valid. Contact your system administrator to renew access.',
    licenseInvalidGoProfile: 'Go to profile'
  },
  license: {
    errors: {
      LICENSE_MISSING: 'You do not have an active license. Please contact the system administrator.',
      LICENSE_EXPIRED: 'Your license has expired. Please renew your license.',
      LICENSE_SUSPENDED: 'Your license has been suspended. Please contact the system administrator.'
    },
    banner: {
      missing: 'No active license — management features are disabled.',
      expired: 'Your license has expired — management features are disabled.',
      suspended: 'Your license is suspended — management features are disabled.',
      inactive: 'Your license is not active — management features are disabled.'
    }
  },
  dashboard: {
    welcome: 'Welcome back,',
    accountTypeSuperadmin: 'Superadmin',
    accountTypeAdmin: 'Account: administrator',
    locationsDescription: 'Quickly select a location.',
    openLocation: 'Open',
    quickAdd: 'Quick Add',
    quickAddDescription: 'Quickly add new items.',
    addEstablishment: 'New Establishment',
    addLocation: 'Locations',
    addNews: 'New News',
    addMenuItem: 'New Item',
    addPromoCode: 'New Promo Code',
    addMembership: 'New membership',
    addReward: 'New Reward',
    addOfficeAdmin: 'New Office Admin',
    adminTools: 'Admin Tools',
    totalAdmins: 'Total Admins',
    openApiDocs: 'API documentation (Swagger)',
    openApiDocsSubtitle: 'Opens in a new browser tab',
    openApiDocsTitle: 'HTTP Basic auth uses server-side Swagger credentials',
    kpi: {
      totalRevenue: 'Total Revenue',
      totalOrders: 'Orders',
      totalCustomers: 'Customers',
      totalItems: 'Items Sold',
      today: 'Today',
      itemsSold: 'Completed orders'
    },
    filters: {
      title: 'Filters',
      dateRange: 'Date Range',
      location: 'Location',
      allLocations: 'All locations',
      teamScope: 'Team & owners',
      assignedAdmin: 'Team member (establishment assignment)',
      allTeamMembers: 'All team members',
      projectOwnerFilter: 'Project owner (system-wide)',
      allProjectOwners: 'All owners',
      reset: 'Reset',
      export: 'Export'
    },
    quickAccess: 'Quick access',
    yourNetwork: 'Your network',
    yourNetworkDescription: 'Overview of establishments and locations.',
    locationsModalTitle: 'All locations – search and browse',
    activeFiltersNote: 'Displayed data reflects the selected period, location, and team / owner filters (when set).'
  },
  customers: {
    title: 'Customers',
    description: 'View and manage customers (guests)',
    searchPlaceholder: 'Name, email, phone...',
    loading: 'Loading customers...',
    noResults: 'No customers',
    noResultsSearch: 'No results for your search',
    emptyDescription: 'Customers will appear here once they register in the app.',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    createdAt: 'Registered',
    view: 'View',
    details: 'Customer details',
    edit: 'Edit',
    backToList: 'Back to list',
    basicInfo: 'Basic information',
    firstName: 'First name',
    lastName: 'Last name',
    birthDate: 'Birth date',
    gender: 'Gender',
    city: 'City',
    save: 'Save',
    analytics: 'Analytics',
    totalOrders: 'Total orders',
    completedOrders: 'Completed orders',
    totalSpent: 'Total spent',
    loyaltyPoints: 'Loyalty points',
    loyaltySourceCard: 'Card (per establishment)',
    loyaltySourceEstablishment: 'Points per establishment',
    loyaltySourceComplex: 'Points per complex',
    loyaltySourceCardAggregate: 'Total on card',
    statusActive: 'Active',
    statusPending: 'Pending',
    statusSuspended: 'Suspended',
    statusRejected: 'Rejected',
    tryDifferentSearch: 'Try a different search term',
    noAnalytics: 'No analytics data available',
    analyticsFiltersTitle: 'Analytics filters',
    resetAnalyticsFilters: 'Reset filters',
    applyAnalyticsFilters: 'Apply filters',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    completionRate: 'Completion rate',
    averageOrderValue: 'Average order value',
    ordersByDay: 'Orders by day',
    spentByDay: 'Spend by day',
    ordersByStatus: 'Orders by status'
  },
  promo: {
    title: 'Promo codes',
    description: 'Manage discount codes per establishment',
    add: 'Add promo code',
    edit: 'Edit promo code',
    createNew: 'New promo code',
    code: 'Code',
    establishment: 'Establishment',
    filterByEstablishment: 'Filter by establishment',
    allEstablishments: 'All establishments',
    discountType: 'Discount type',
    discountValue: 'Discount value',
    discountPercentage: 'Percentage',
    discountFixed: 'Fixed amount',
    minOrderAmount: 'Min. order amount',
    maxUses: 'Max. uses',
    unlimited: 'Unlimited',
    usedCount: 'Used',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    isActive: 'Active',
    loading: 'Loading promo codes...',
    noResults: 'No promo codes',
    noResultsFilter: 'No promo codes for selected establishment',
    emptyDescription: 'Add your first promo code for discounts and promotions.',
    emptyFilterDescription: 'Select another establishment or add a promo code for this one.',
    confirmDelete: 'Are you sure you want to delete this promo code?',
    backToList: 'Back to list',
    save: 'Save'
  },
  membership: {
    title: 'Memberships',
    description: 'Ongoing member discounts. A guest can be in one program per project.',
    add: 'Add membership',
    edit: 'Edit membership',
    createNew: 'New membership',
    details: 'Membership details',
    view: 'Open',
    name: 'Name',
    namePlaceholder: 'e.g. Gold club',
    scope: 'Scope',
    scopeProject: 'Whole project (license)',
    scopeEstablishment: 'Establishment',
    scopeLocation: 'Location',
    joinCode: 'Activation code',
    joinCodePlaceholder: 'e.g. MEMBER10',
    joinCodeHint: 'The code is generated automatically. Guests join via code, QR or link. Generate a new one from the program details.',
    joinUrl: 'Join link',
    regenerateCode: 'New code',
    qrTitle: 'Join QR code',
    qrHint: 'The guest scans the QR with the phone camera or opens the link — Lylup enrolls them. The same code can be typed in Account → Membership. Download or print the QR for cards, tables and flyers.',
    copyCode: 'Copy code',
    copyLink: 'Copy link',
    downloadQr: 'Download QR',
    printQr: 'Print QR',
    printQrHint: 'Scan the QR to join the club',
    members: 'Members',
    membersCount: 'Members',
    noMembers: 'No members yet.',
    joinedAt: 'Joined',
    maxMembers: 'Max. members',
    unlimited: 'Unlimited',
    loading: 'Loading memberships...',
    noResults: 'No membership programs',
    noResultsFilter: 'No programs for the selected establishment',
    emptyDescription: 'Add the first program if you want member discounts. Optional.',
    emptyFilterDescription: 'Pick another establishment or add a program for this scope.',
    confirmDelete: 'Delete this membership program? Members will lose their status.',
    backToList: 'Back to list',
    backToDetails: 'Back to program',
    discountType: 'Discount type',
    discountValue: 'Discount value',
    discountValuePercent: 'Discount percentage',
    discountValueEuro: 'Discount amount',
    discountValuePercentHint: 'Percentage off the order total (1–100).',
    discountValueEuroHint: 'Fixed amount subtracted from the order.',
    discountPercentage: 'Percentage',
    discountFixed: 'Fixed amount',
    minOrderAmount: 'Min. order amount',
    isActive: 'Active',
    allEstablishments: 'All establishments',
    filterByEstablishment: 'Select establishment',
    filterByLocation: 'Select location',
    selectEstablishmentFirst: 'Select an establishment first',
    codeRegenerated: 'A new code was generated. The old code no longer works.'
  },
  establishments: {
    title: 'Establishments',
    add: 'Add Establishment',
    editEstablishment: 'Edit Establishment',
    newEstablishment: 'New Establishment',
    basicInfo: 'Basic Information',
    website: 'Website',
    logo: 'Logo',
    details: 'Details',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    activate: 'Activate',
    deactivate: 'Deactivate',
    saveChanges: 'Save Changes',
    saveEstablishment: 'Save Establishment',
    confirmDelete: 'Are you sure you want to delete this establishment?',
    deleteWarning: 'This action is irreversible and permanently deletes the establishment and all related data.',
    deleteRelIntro: 'Related data that will also be deleted:',
    deleteRelLocations: 'Locations',
    deleteRelDetails: 'Location details',
    deleteRelWorkingHours: 'Working hours',
    deleteRelOfficeAdmins: 'Office admins',
    deleteRelOfficeAdminRefreshTokens: 'Office admin refresh tokens',
    deleteRelOfficeAdminDeviceTokens: 'Office admin device tokens',
    deleteRelPromoCodes: 'Promo codes',
    deleteRelUserEstablishments: 'User-establishment links',
    deleteRelAdminEstablishments: 'Admin-establishment links',
    deleteRelComplexLinks: 'Complex-establishment links',
    deleteRelTransactions: 'Transactions',
    deleteRelCardPoints: 'Card establishment points',
    deleteRelQrCodes: 'QR codes',
    deleteRelQrTransactions: 'QR transactions',
    deleteRelOrders: 'Orders',
    deleteRelOrderItems: 'Order items',
    deleteRelTables: 'Tables',
    deleteRelRewards: 'Rewards',
    deleteRelUserRewards: 'User rewards',
    deleteRelNews: 'News',
    deleteRelNewsImages: 'News images',
    deleteRelMenuCategories: 'Menu categories',
    deleteRelMenuItems: 'Menu items',
    deleteError: 'Error deleting establishment. Please try again.',
    backToEstablishment: 'Back to Establishment',
    backToEstablishments: 'Back to Establishments',
    restaurant: 'Restaurant',
    hotel: 'Hotel',
    bar: 'Bar / Café',
    other: 'Other',
    active: 'Active',
    inactive: 'Inactive',
    created: 'Created',
    locations: 'Locations',
    addLocation: 'Add Location',
    generateQr: 'Generate QR',
    qrModalTitle: 'Establishment QR code',
    noLocations: 'No Locations',
    addFirstLocation: 'Add the first location for this establishment',
    saveLocation: 'Save Location',
    allTypes: 'All types',
    restaurants: 'Restaurants',
    hotels: 'Hotels',
    bars: 'Bars',
    others: 'Other',
    manageEstablishments: 'Manage your establishments, locations and their data',
    tryDifferentSearch: 'Try a different search term',
    addNewEstablishment: 'Add a new establishment by clicking the "Add Establishment" button',
    lastUpdated: 'Last updated',
    basicInfoSection: 'Basic Information',
    basicInfoSectionLead: 'Name, type, and short description shown to users in the app.',
    brandingSection: 'Visual identity',
    brandingSectionLead: 'Logo, card background colour, and wide header image for the mobile app.',
    onlineSection: 'Website and visibility',
    onlineSectionLead: 'External link and whether this establishment is active for customers.',
    onlineStatusHint: 'Inactive establishments are hidden from users in the app.',
    establishmentName: 'Establishment Name',
    establishmentNamePlaceholder: 'e.g. McDonald\'s, Hilton Hotels...',
    establishmentType: 'Establishment Type',
    establishmentDescription: 'Establishment Description',
    establishmentDescriptionPlaceholder: 'Enter a brief description of the establishment...',
    nameRequiredOneLocale: 'Enter the name in Croatian or English.',
    descriptionRequiredOneLocale: 'Enter the description in Croatian or English.',
    websitePlaceholder: 'https://www.example.com',
    additionalInfoSection: 'Additional Information',
    dragAndDrop: 'Drag and drop your image here',
    or: 'or',
    chooseLogo: 'Choose an image',
    invalidImageType: 'Please use JPEG, PNG, GIF, WebP, or SVG (e.g. logos).',
    logoHint:
      'Smaller brand mark on cards and lists in the app. Prefer a square or transparent PNG/SVG.',
    logoBackgroundColor: 'Logo background color (mobile app)',
    logoBackgroundColorHint:
      'Shown behind transparent logos on cards. Leave empty to use the app default. Format: #RRGGBB.',
    logoBackgroundColorPlaceholder: '#D8670C',
    logoBackgroundColorClear: 'Clear color',
    logoBackgroundColorInvalid: 'Color must be empty or a valid #RRGGBB hex (e.g. #D8670C).',
    heroImage: 'Header / hero image',
    heroImageHint:
      'A larger image for the mobile app (e.g. header, restaurant detail). Prefer a wide photo; JPG, PNG, or WebP.',
    heroImageUploadWait: 'Please wait until the header image upload finishes.',
    saveError: 'An error occurred while saving. Please try again.',
    pointsSection: 'Points Settings',
    pointsSectionLead: 'The program is set on the project; here you configure points rates for this venue.',
    pointsMode: 'Points Collection Mode',
    pointsModeInherited: 'Inherited from project',
    pointsModeInheritedHint: 'Change the program under Admins → Projects. Establishments only inherit the setting.',
    pointsModeCard: 'Loyalty Card',
    pointsModeCardDescription: 'Points are awarded when scanning the card or manual purchase entry',
    pointsModeOrder: 'Automatic on Order',
    pointsModeOrderDescription: 'Points are automatically awarded when the user completes an order',
    pointsPerEuroScan: 'Points per 1 € (scan/manual)',
    pointsPerEuroScanPlaceholder: '0.1',
    pointsPerEuroScanHelp: 'E.g. 0.1 means 1 point for every 10 €',
    pointsPerEuroOrder: 'Points per 1 € (order)',
    pointsPerEuroOrderPlaceholder: '1',
    pointsPerEuroOrderHelp: 'E.g. 1 means 1 point for every 1 €',
    pointsPerEuro: 'points per €',
    menuScopeSection: 'Menu scope',
    menuScopeSectionLead: 'One menu for the whole establishment or overrides per location.',
    menuScopeLabel: 'How offer is configured',
    menuScopeGlobal: 'Global establishment menu',
    menuScopeGlobalDescription: 'All locations under this establishment use the same menu.',
    menuScopeLocation: 'Menu per location',
    menuScopeLocationDescription: 'Locations can have menu overrides with fallback to the global menu.'
  },
  locations: {
    title: 'Locations',
    listDescription: 'All project locations — hours, tables, POS and ordering are configured here.',
    searchPlaceholder: 'Search location, establishment or address…',
    allEstablishments: 'All establishments',
    noEstablishmentsTitle: 'No establishments',
    noEstablishmentsMessage: 'Add an establishment first, then locations under it.',
    noLocationsYetTitle: 'No locations yet',
    noLocationsNeedEstablishmentMessage:
      'Locations belong to an establishment. Create an establishment first, then add a location to it.',
    noLocationsTitle: 'No locations',
    noLocationsMessage: 'No locations yet. Add the first location on an establishment.',
    tryDifferentSearch: 'Try a different search term or filter.',
    unknownEstablishment: 'Unknown establishment',
    errorLoadingList: 'Error loading locations',
    newLocation: 'New Location',
    editLocation: 'Edit Location',
    locationName: 'Location Name',
    locationNamePlaceholder: 'e.g. Downtown, West Side...',
    addressAndContacts: 'Address and Contacts',
    address: 'Address',
    addressPlaceholder: 'Start typing to search for address...',
    addressHelp: 'Select an address from the search suggestions, or enter latitude and longitude manually.',
    addressRequired: 'Please enter the location address',
    coordinatesRequired: 'Select an address from search, or enter latitude and longitude.',
    googleMapsKeyMissing: 'Address search is unavailable because VITE_GOOGLE_MAPS_API_KEY is not set. Enter latitude and longitude manually.',
    latitude: 'Latitude',
    longitude: 'Longitude',
    email: 'Email',
    emailPlaceholder: 'example: info.location.com',
    phone: 'Phone Number',
    phonePlaceholder: '+1 234 567 8901',
    workingHours: 'Working Hours',
    dayFrom: 'From day',
    dayTo: 'To day',
    timeFrom: 'From',
    timeTo: 'To',
    addWorkingHours: 'Add another working hours',
    backToLocation: 'Back to location details',
    backToLocations: 'Back to locations',
    backToEstablishment: 'Back to establishment',
    noOfficeAdminWarning: 'No active employee — orders will not be visible in the app',
    inviteOfficeAdmin: 'Invite employee',
    loadingLocation: 'Loading location...',
    contactDetails: 'Contact Details',
    mapLocation: 'Map Location',
    noWorkingHours: 'No working hours defined',
    locationNotAvailable: 'Location data is not available',
    detailsNotAvailable: 'Location details not available',
    coordinatesNotAvailable: 'Geographic coordinates not available',
    locationIdNotFoundInUrl: 'Location ID not found in URL',
    emptyApiResponse: 'Empty response received from API',
    errorFetchingLocation: 'Error fetching location',
    notLoggedInOrSessionExpired: 'You are not logged in or your session has expired. Please log in again.',
    locationNotFound: 'Location not found.',
    errorLoading: 'Error loading',
    unknownError: 'Unknown error',
    noServerResponse: 'No response from server. Please check your internet connection.',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }
  },
  pos: {
    title: 'POS Integration',
    noIntegration: 'No POS integration configured',
    noIntegrationDescription: 'Add an integration to connect this location to a POS system.',
    addIntegration: 'Add Integration',
    editIntegration: 'Edit Integration',
    deleteIntegration: 'Remove Integration',
    provider: 'POS System',
    selectProvider: 'Select POS system',
    credentials: 'Credentials',
    credentialsDescription:
      'For Remaris use keys: api_base_url, gm_api_key, register_id, and optionally system_name. Values are stored server-side.',
    addCredential: 'Add field',
    credentialKeyPlaceholder: 'e.g. api_key, username...',
    credentialValuePlaceholder: 'Enter value',
    isActive: 'Integration active',
    status: 'Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    lastSync: 'Last sync',
    lastSyncNever: 'Never',
    lastSyncError: 'Error during last sync',
    syncMenu: 'Sync Menu',
    syncMenuDescription: 'Fetch articles and prices from the POS system.',
    syncInProgress: 'Sync in progress...',
    syncSuccess: 'Menu synced successfully',
    syncFailed: 'Sync failed',
    confirmDelete: 'Are you sure you want to remove the POS integration?',
    confirmDeleteWarning: 'This action will remove the integration and all article mappings.',
    saveIntegration: 'Save Integration',
    integrationCreated: 'POS integration created successfully',
    integrationUpdated: 'POS integration updated successfully',
    integrationDeleted: 'POS integration removed successfully',
    errorCreating: 'Error creating integration',
    errorDeleting: 'Error deleting integration',
    errorLoading: 'Error loading POS integration',
    orderHubBaseUrl: 'Order Hub base URL (for POS configuration)',
    posStoreId: 'Store ID',
    oneTimeApiKeyWarning:
      'Copy this API key now — it will not be shown again. Give it to Remaris with the Order Hub URL. If you lost it, use the button to generate a new key (the old one stops working).',
    orderingEnabled: 'Online ordering enabled for POS',
    testConnection: 'Test Remaris SEO connection',
    testConnectionOk: 'Remaris SEO connection succeeded',
    testConnectionFail: 'Remaris SEO connection failed',
    dismissOneTimeKey: 'Dismiss',
    providersLoadWarning:
      'Could not load POS providers from the server or the list was empty — showing the built-in Remaris option. Run DB migrations (pos_providers seed) if you need the list from the database.',
    remarisCredentialsIntro:
      'These fields must match the exact JSON keys the backend sends to the Remaris SEO API (1:1 mapping).',
    remarisJsonKeyHint: 'JSON key',
    credentialsGenericDescription:
      'For other POS systems, add key–value pairs as required by that integration.',
    remarisEditHint:
      'Fields are pre-filled with the saved configuration. Change only what you need.',
    credentialConfigured: 'Saved',
    credentialPlaceholder: 'Leave empty to keep the existing value',
    showCredential: 'Show',
    hideCredential: 'Hide',
    copyCredential: 'Copy',
    credentialCopied: 'Copied',
    credentialCopyFailed: 'Could not copy',
    remarisApiBaseUrl: 'Remaris Cloud base URL',
    remarisApiBaseUrlHelp:
      'Full URL with https:// — Remaris Cloud host only, without the SEO path (e.g. https://development.remaris.hr).',
    remarisGmApiKey: 'GM-ApiKey',
    remarisGmApiKeyHelp:
      'Value sent in the GM-ApiKey HTTP header when calling the Remaris SEO API.',
    remarisRegisterId: 'Register ID',
    remarisRegisterIdHelp:
      'Sent as the RegisterId query parameter (exact name used by Remaris).',
    remarisSystemName: 'System name (optional)',
    remarisSystemNameHelp:
      'Optional. Remaris filters items by attribute — a wrong value (e.g. "test") returns an empty menu. Leave blank unless Remaris gave you the exact name.',
    remarisFieldRequired: 'Required field: {field}',
    remarisFillAllRequired:
      'Fill all required Remaris fields (api_base_url, gm_api_key, register_id).',
    servusCredentialsIntro:
      'These fields map to the Servus QR API (HTTP Basic Auth + location client_uid).',
    servusEditHint:
      'Credentials are not shown for security. Re-enter them only if you want to replace stored values.',
    servusApiBaseUrl: 'Servus API base URL',
    servusApiBaseUrlHelp:
      'Default: https://QROrder.servus-app.com:44500 — change only if Servus uses a different host.',
    servusUsername: 'Username (Basic Auth)',
    servusUsernameHelp: 'HTTP Basic Auth username provided by Servus.',
    servusPassword: 'Password (Basic Auth)',
    servusPasswordHelp: 'HTTP Basic Auth password — stored securely on the server.',
    servusClientUid: 'Location client UID',
    servusClientUidHelp:
      'Venue UUID in Servus (used in GET /api/getmenu/{client_uid}).',
    servusFillAllRequired: 'Fill all required Servus fields (username, password, client_uid).',
    testServusConnection: 'Test Servus connection',
    servusPushModelHelp:
      'Servus uses a push model — orders from the mobile app are sent to the POS automatically. No Order Hub URL or POS API key is required.',
    errors: {
      generic: 'The POS operation failed. Check your configuration and try again.',
      credentials_missing: 'Required credentials are missing. Check all integration fields.',
      network_unavailable: 'Could not connect to Remaris Cloud. Check api_base_url (must start with https://) and network access.',
      remaris_invalid_base_url: 'api_base_url is invalid — use a full URL with https:// (e.g. https://development.remaris.hr).',
      timeout: 'The POS server did not respond in time. Try again in a few minutes.',
      menu_empty: 'Remaris menu is empty. Check Register ID and System name — a value like "test" filters out all items.',
      menu_invalid: 'The POS response is not a valid menu. Check your credentials.',
      integration_missing: 'No POS integration was found for this location.',
      provider_unsupported: 'The selected POS provider is not supported.',
      servus_unauthorized: 'Servus rejected the login — username or password is incorrect.',
      servus_invalid_request:
        'Servus rejected the request. Check the location Client UID (must be a valid UUID) and other fields.',
      servus_not_found: 'The location (Client UID) was not found in Servus.',
      servus_forbidden: 'You do not have access to this location in Servus.',
      servus_server_error: 'The Servus server is temporarily unavailable. Try again later.',
      servus_order_rejected: 'Servus did not accept the order. Check item mappings.',
      remaris_unauthorized: 'Remaris rejected the request — GM-ApiKey is invalid or expired.',
      remaris_not_found: 'Remaris could not find the register. Check Register ID.',
      remaris_server_error: 'The Remaris server is temporarily unavailable. Try again later.',
      remaris_invalid_menu: 'Remaris returned an unexpected menu format. Check Register ID and API key.',
    },
    regenerateExternalApiKey: 'New POS API key',
    regenerateExternalApiKeyHelp:
      'Use if you lost the key or need to rotate it (e.g. after a leak). The old key stops working immediately — enter the new key in Remaris or POS orders will fail.',
    confirmRegenerateApiKeyTitle: 'Generate a new API key?',
    confirmRegenerateApiKeyBody:
      'The previous Standard External Orders key stops working at once. The POS must be updated with the new key; Order Hub URL and Store ID stay the same. Continue?',
    regenerateApiKeySuccess: 'New key is ready — copy it now and give it to whoever configures Remaris.',
    regenerateApiKeyFail: 'Could not generate a new key',
    mappings: {
      title: 'Item mappings (POS ↔ menu)',
      subtitle:
        'Links a Lylup item to an existing POS article ID. Does not create a product on Remaris — create new products on the cash register, then sync. Use manual mapping when sync does not match 1:1 or you need to fix a link.',
      addMapping: 'Add mapping',
      noIntegrationTitle: 'POS integration not configured',
      noIntegrationDescription: 'Add and activate the POS integration first, then you can map items.',
      emptyTitle: 'No mapped items',
      emptyDescription:
        'Mappings are usually filled in automatically during menu sync. Add them manually only to link an existing Lylup item to a POS ID — this does not create an article on the cash register.',
      colMenuItem: 'Menu item',
      colPOSArticleID: 'POS Article ID',
      colPOSArticleCode: 'POS Article Code',
      colPOSCategoryID: 'POS Category ID',
      colPOSIds: 'POS ID',
      colActions: 'Actions',
      inApp: 'In app',
      availabilityOn: 'Shown in the app at this location',
      availabilityOff: 'Hidden in the app at this location',
      menuItemMissing: '(menu item deleted)',
      selectMenuItem: 'Choose menu item',
      alreadyMapped: 'already mapped',
      articleIdPlaceholder: 'e.g. 516',
      articleIdHelp: 'Numeric or textual article ID in the POS. Must match exactly what the POS uses.',
      articleCodePlaceholder: 'e.g. LIMONA-25',
      articleCodeHelp: 'Optional — internal article code (if the POS uses one).',
      categoryIdPlaceholder: 'e.g. 15',
      articleIdRequired: 'POS Article ID is required.',
      addTitle: 'Add item mapping',
      editTitle: 'Edit item mapping',
      formDescription:
        'A mapping links one menu item to one POS article. There can be only one mapping per menu item per location.',
      deleteTitle: 'Remove mapping?',
      deleteWarning:
        'The menu item stays, but will no longer be sent to the POS as a recognised article. You can re-map at any time.',
      errorLoading: 'Could not load mappings',
      errorLoadingMenu: 'Could not load menu',
      errorSaving: 'Could not save the mapping',
      errorDeleting: 'Could not delete the mapping',
      errorAvailability: 'Could not update availability at this location'
    }
  },
  broadcast: {
    title: 'Send Message',
    targetAudience: 'Recipients',
    allMyCustomers: 'All my customers',
    targetHelp: 'Select an establishment to send only to its customers, or leave empty for all.',
    filterByLocation: 'Filter by location',
    allLocations: 'All locations',
    messageTitle: 'Message title',
    titlePlaceholder: 'e.g. Special offer!',
    messageBody: 'Message body',
    bodyPlaceholder: 'Enter the message text that users will see...',
    send: 'Send',
    sending: 'Sending...',
    success: 'Message sent successfully!',
    noUsers: 'No users to send to. Users must place an order first.',
    noDevices: 'Users have no registered devices for push notifications.',
    failed: 'Sending failed',
    error: 'Error sending message',
    statsText: 'Result',
    statsUsers: 'users',
    statsDevices: 'devices',
    statsSent: 'sent'
  },
  purchase: {
    title: 'Enter Purchase',
    userIdentifier: 'User email or phone',
    userIdentifierPlaceholder: 'e.g. user@email.com or +385...',
    userIdentifierHelp: 'Enter the user\'s email address or phone number',
    location: 'Location',
    selectLocation: 'Select location',
    amount: 'Purchase amount',
    amountPlaceholder: '0.00',
    amountHelp: 'User will receive {points} points (1 point per 10€)',
    description: 'Description (optional)',
    descriptionPlaceholder: 'e.g. In-store purchase',
    submit: 'Add points',
    submitting: 'Saving...',
    success: 'Purchase recorded successfully!',
    error: 'Error recording purchase',
    resultUser: 'User',
    resultPoints: 'Points added',
    resultTotal: 'Total points'
  },
  payments: {
    tab: 'Online payments',
    title: 'Online payments',
    lead: 'Enable card payments in the mobile app before the order reaches the POS. Without integration, customers can still order and pay on site.',
    noIntegration: 'Online payments not configured',
    noIntegrationDescription: 'The project owner has chosen this payment provider in Project settings. Configure this establishment next.',
    noIntegrationLockedHint: 'This establishment uses the payment provider chosen in Project settings.',
    addNamedIntegration: 'Set up {name}',
    projectProviderUnset: 'Online payment provider not chosen',
    projectProviderUnsetHint: 'The project owner must choose Monri, Corvus Pay, or Stripe in My Profile → Project settings before this establishment can connect.',
    providerChosenInProjectSettings: 'Set for the whole project in Project settings.',
    establishmentOwnMerchantHint: 'Use this establishment’s own merchant account credentials — not the project admin’s.',
    addIntegration: 'Set up online payments',
    editIntegration: 'Edit settings',
    deleteIntegration: 'Remove integration',
    saveIntegration: 'Save settings',
    provider: 'Payment provider',
    selectProvider: 'Select provider',
    chooseProvider: 'Choose provider',
    chooseProviderHelp: 'One online provider per establishment. To switch, delete and create a new integration.',
    providerLockedHint: 'Provider cannot be changed after creation.',
    credentials: 'Credentials',
    credentialsEditHint: 'Secrets are stored and never shown. Leave fields empty to keep the current values.',
    credentialSavedPlaceholder: 'Saved — leave empty to keep',
    credentialSavedBadge: 'Saved',
    credentialsGenericIntro: 'Enter the credentials provided by your payment provider.',
    monriCredentialsIntro: 'Authenticity token and merchant key come from the Monri merchant dashboard (ipgtest.monri.com / ipg.monri.com).',
    corvusCredentialsIntro: 'Store ID and Secret Key are in the Corvus Pay Merchant Portal.',
    stripeCredentialsIntro: 'Stripe Connect onboarding runs in this tab. You do not enter platform API keys.',
    settingsTitle: 'Billing settings',
    currency: 'Currency',
    currencyHelp: 'Currency used for online checkout.',
    testMode: 'Test / sandbox mode',
    testModeHelp: 'On = provider test environment. Off = production.',
    monriTestModeHelp: 'On = Monri TEST (ipgtest.monri.com). Off = production (ipg.monri.com).',
    stripeTestModeFromProject: 'Sandbox vs live is set in My Profile → Project settings for this project’s Stripe account.',
    isActive: 'Online payments active',
    portalSetupTitle: 'Provider portal checklist',
    portalSetupHelp: 'After saving, register the webhook URL in the provider portal:',
    monriPortalSetupHelp: 'In the Monri dashboard you only need the authenticity token and merchant key. The app sends the return URL with each payment — nothing to paste for local use.',
    webhookUrl: 'Webhook URL',
    webhookUrlHelp: 'Copy this URL into the provider portal so payment confirmations reach the backend.',
    monriCallbackUrl: 'Callback URL (optional)',
    monriCallbackUrlHelp: 'Production only, with a public HTTPS server. Paste this into Monri dashboard Callback URL if you want Monri to notify us even if the customer closes the app.',
    corvusWebhookUrlHelp: 'In Corvus Merchant Portal, set success/postback URL to this address.',
    stripeWebhookUrlHelp: 'In Stripe Dashboard → Webhooks, add this endpoint and event checkout.session.completed.',
    monriAuthenticityToken: 'Authenticity token',
    monriAuthenticityTokenHelp: 'Authenticity token from Monri merchant settings.',
    monriMerchantKey: 'Merchant key',
    monriMerchantKeyHelp: 'Key / merchant key from Monri API settings — stored securely on the server.',
    corvusStoreId: 'Store ID',
    corvusStoreIdHelp: 'Store identifier in Corvus Pay Merchant Portal.',
    corvusSecretKey: 'Secret Key',
    corvusSecretKeyHelp: 'HMAC signing secret — stored securely on the server.',
    corvusCheckoutBaseUrl: 'Checkout URL (optional)',
    corvusCheckoutBaseUrlHelp: 'Leave empty for test-wallet / wallet.corvuspay.com based on test mode.',
    corvusCheckoutBaseUrlPlaceholder: 'https://wallet.corvuspay.com/checkout',
    corvusApiVersion: 'API version (optional)',
    corvusApiVersionHelp: 'Defaults to 1.4 if left empty.',
    corvusApiVersionPlaceholder: '1.4',
    stripeSecretKey: 'Secret key',
    stripeSecretKeyHelp: 'Stripe Secret key (sk_test_… or sk_live_…).',
    stripeWebhookSecret: 'Webhook signing secret',
    stripeWebhookSecretHelp: 'whsec_… from Stripe webhook endpoint — required for signature verification.',
    stripePublishableKey: 'Publishable key (optional)',
    stripePublishableKeyHelp: 'pk_test_… / pk_live_… — for future mobile SDK; not required for hosted checkout.',
    checkoutLanguage: 'Checkout language',
    checkoutLanguageHelp: 'ISO language code on the payment form (e.g. hr, en).',
    checkoutLanguagePlaceholder: 'en',
    flowStepConfigure: 'Configure provider',
    flowStepCheckout: 'Customer pays in app',
    flowStepOrder: 'Paid order is created',
    cashOnSiteNote: 'Without online integration, customers can still order and pay cash/card at the location.',
    statusOnlineActive: 'Online payments enabled',
    statusOnlineActiveHint: 'Customers see card payment at checkout in the app.',
    statusOnlinePending: 'Finish Stripe onboarding',
    statusOnlinePendingHint:
      'The integration is saved, but customers will not see card checkout until identity verification is complete.',
    statusOnlineInactive: 'Online payments disabled',
    statusOnlineInactiveHint: 'Integration is saved but inactive — customers pay on site only.',
    updatedAt: 'Last updated',
    testConnection: 'Test connection',
    testConnectionOk: 'Provider connection succeeded',
    testConnectionFail: 'Connection test failed — check credentials',
    oneTimeWebhookSecretWarning: 'Copy the webhook secret now — it will not be shown again.',
    dismissSecret: 'Dismiss',
    copy: 'Copy',
    copied: 'Copied to clipboard',
    copyFailed: 'Copy failed',
    yes: 'Yes',
    no: 'No',
    fillRequiredCredentials: 'Fill all required credential fields.',
    confirmDelete: 'Remove online payments?',
    confirmDeleteWarning: 'Customers will no longer pay by card in the app. Pay-on-site orders still work.',
    integrationCreated: 'Online payments configured successfully',
    integrationUpdated: 'Payment settings updated',
    integrationDeleted: 'Online payments removed',
    errorLoading: 'Error loading payment settings',
    errorSaving: 'Error saving payment settings',
    errorDeleting: 'Error removing integration',
    providersLoadWarning: 'Provider list unavailable from server — showing known options.',
    monriSetup1: 'Copy the authenticity token and merchant key from Monri dashboard API settings.',
    monriSetup2: 'Turn test mode on for ipgtest.monri.com, off for production.',
    monriSetup3: 'The app sends the return URL with each payment. You do not paste it in the dashboard.',
    corvusSetup1: 'Set postback / success URL in Corvus Merchant Portal.',
    corvusSetup2: 'Verify Store ID and Secret Key.',
    corvusSetup3: 'Use test portal and enable test mode for sandbox.',
    stripeSetup1: 'Create a webhook endpoint in Stripe Dashboard with the URL below.',
    stripeSetup2: 'Subscribe to checkout.session.completed.',
    stripeSetup3: 'Copy signing secret (whsec_…) into Webhook signing secret field.',
    connectTitle: 'Stripe Connect',
    connectLead: 'Complete identity verification (OIB, documents, bank account) here. Status updates automatically after Stripe confirms requirements.',
    connectStart: 'Set up Stripe',
    connectContinue: 'Continue onboarding',
    connectHostedHint: 'Opens the Stripe hosted setup page (connect.stripe.com/setup/...). Use Chrome or Safari if a tab gets stuck on embedded/loading.',
    connectAccountId: 'Connected account ID',
    connectReadyHint: 'Stripe transfers are active. Guests can pay by card when online payments are enabled for this establishment.',
    connectErrorStatus: 'Could not load Stripe Connect status.',
    connectErrorStart: 'Could not start Stripe onboarding.',
    connectPlatformDisconnected: 'The project owner must connect the project Stripe account in Profile → Project settings before this establishment can start onboarding.',
    connectStatus: {
      not_started: 'Not started',
      in_progress: 'In progress',
      action_required: 'Action required',
      active: 'Active',
    },
    errors: {
      generic: 'Payment operation failed. Check configuration.',
      credentials_missing: 'Required payment credentials are missing.',
      provider_unsupported: 'Selected payment provider is not supported.',
      integration_missing: 'Payment integration for this establishment was not found.',
      checkout_failed: 'Checkout failed. Check Shop ID, Secret Key, and test/live mode.',
      webhook_invalid: 'Webhook signature is invalid.',
      connect_not_ready: 'Stripe payments are unavailable until Connect onboarding is complete.',
    },
  },
  ordering: {
    tab: 'Ordering & delivery',
    title: 'Ordering & delivery',
    lead: 'Configure whether customers pick up orders at your location or request delivery in the mobile app.',
    edit: 'Edit settings',
    fulfillmentOptions: 'Fulfillment options',
    pickupEnabled: 'Pickup at location',
    pickupEnabledHint: 'Customer collects the order at your venue.',
    deliveryEnabled: 'Delivery',
    deliveryEnabledHint: 'Customer enters a delivery address in the app.',
    fulfillmentHelp: 'At least one option must stay enabled. Delivery is optional and off by default.',
    deliverySettings: 'Delivery settings',
    deliveryFee: 'Delivery fee (€)',
    minimumOrder: 'Minimum order for delivery (€)',
    onlineRequiredForDelivery: 'Require online payment for delivery',
    onlineRequiredHelp: 'When enabled, delivery orders must be paid online; cash on site is only for pickup.',
    atLeastOneOption: 'Enable pickup or delivery (or both).',
    saving: 'Saving…',
    loadError: 'Could not load ordering settings.',
    saveError: 'Could not save ordering settings.',
  },
  menus: {
    title: 'Menus & price lists',
    items: 'Items',
    itemsOne: 'item',
    itemsFew: 'items',
    itemsMany: 'items',
    addCategory: 'Add Category',
    addItem: 'Add Item',
    newItemTitle: 'New Menu Item',
    itemData: 'Item details',
    editCategory: 'Edit Category',
    newCategory: 'New Category',
    newCategoryTitle: 'New Category',
    categoryData: 'Category details',
    editItem: 'Edit Item',
    newItem: 'New Item',
    price: 'Price',
    image: 'Image',
    noCategories: 'No Categories',
    noItems: 'No Items',
    deleteCategory: 'Delete Category',
    confirmDeleteCategory: 'Are you sure you want to delete this category?',
    confirmDeleteCategoryWarning: 'This action will permanently hide the category from the menu. All items in this category will also be hidden.',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    confirmDeleteItemWarning: 'This action will permanently hide the item from the menu.',
    orderNumber: 'Order Number',
    createEstablishmentFirst: 'You need to create an establishment first before you can add menus or price lists.',
    categoriesCount: 'categories',
    activeLocationsLabel: 'active locations',
    viewMenu: 'View offer',
    noCategoriesToView: 'No categories yet. Add a category first to view the offer.',
    cardGlobalScope: 'Global offer for establishment',
    cardLocationScope: 'Offer by locations',
    cardEmptyDescription: 'Offer is empty. Open offer view and add your first category.',
    cardGlobalModeDescription: 'In offer view you edit categories and items shared across all establishment locations.',
    cardLocationModeDescription: 'In offer view you select a location and edit its override settings with global fallback.',
    saveCategory: 'Save Category',
    saveMenuItem: 'Save Item',
    outOfStock: 'Out of Stock',
    markAsAvailable: 'Mark as Available',
    outOfStockHelp: 'Mark if the product is currently unavailable. Users on the mobile app will see that the product is out of stock.',
    posBadgeSynced: 'POS: {id}',
    posBadgeSyncedTooltip: 'Linked to POS article {id} — can be issued on the cash register.',
    posBadgeMissing: 'Not mapped',
    posBadgeMissingTooltip: 'No POS article is linked — this item will not appear on the mobile app and cannot be ordered until it is mapped in "POS menu mappings".',
    posSectionTitle: 'Cash register link (POS)',
    posSectionHint: 'Enter the article ID from the Remaris cash register so this item can be issued on a fiscal receipt and shown in the mobile app. Leave empty to remove the link.',
    posArticleId: 'POS Article ID',
    posArticleIdPlaceholder: 'e.g. 4711',
    posArticleIdHelp: 'Numeric article ID inside the Remaris cash register (required for fiscalisation).',
    posArticleCode: 'POS Article Code',
    posArticleCodePlaceholder: 'optional',
    posArticleCodeHelp: 'Optional Remaris article code/SKU.',
    posUnmappedWarning: 'This item is currently not linked to the cash register — it will only be visible in the backoffice and cannot be ordered from the mobile app.',
    posModeBannerTitle: 'Menu comes from the POS (cash register)',
    posModeBannerBody:
      'Create/change products and prices on the Remaris cash register, then sync on the location. Here you can enrich image, description and availability. Article mapping links a Lylup item to an existing POS article ID (e.g. when sync does not match 1:1) — it does not create a product on the cash register.',
    posModeBannerCta: 'Open POS on location',
    posModeCreateBlocked:
      'With an active POS integration, new categories and items are not added here — use menu sync from the cash register.',
    posModeCatalogLockedHint:
      'Name and price come from the cash register. Changes in Lylup are not written back to Remaris; the next sync may overwrite them.',
    posModeMappedFieldsLocked: 'These fields are managed by the cash register. Edit image, description or availability below.',
    posModeDeleteCategoryHint: 'Hide in Lylup (next sync restores it if it still exists on the POS)',
    posModeDeleteItemHint: 'Hide in Lylup (next sync restores it if it still exists on the POS)',
    posModeEditCategoryHint: 'Edit description and order (name comes from the POS)',
    posModeEditItemHint: 'Edit image, description and availability (name and price come from the POS)',
    backToMenu: 'Back to Menu',
    categoryName: 'Category Name',
    categoryNamePlaceholder: 'e.g. Appetizers, Main Courses, Desserts...',
    categoryDescription: 'Category Description',
    categoryDescriptionPlaceholder: 'Optional category description',
    itemName: 'Item Name',
    itemNamePlaceholder: 'e.g. Chicken Burger, Tiramisu...',
    itemDescription: 'Item Description',
    itemDescriptionPlaceholder: 'Optional item description',
    activeCategory: 'Active Category',
    categoryHelp: 'Name of the category to be displayed in the menu',
    categoryDescHelp: 'Optional description that explains the content of the category',
    orderHelp: 'Determines the order of the category in the menu (lower number = displayed earlier)',
    activeHelp: 'Inactive categories will not be shown to users',
    categoryRequired: 'Please select a category',
    itemHelp: 'Name of the item to be displayed in the menu',
    itemDescHelp: 'Optional description that details the item, e.g. ingredients',
    priceHelp: 'Enter the price in euros (e.g. 5.99)',
    imageHelp: 'Optional, add an image that represents this menu item',
    itemOrderHelp: 'Determines the display order within the category (lower number = displayed earlier)',
    noCategoriesDescription: 'This establishment has no menu categories defined yet. Start by adding a new category.',
    manageMenus: 'Manage menus and price lists for your establishments',
    loadingEstablishments: 'Loading establishments...',
    noEstablishments: 'No establishments available',
    specialPrice: 'Special price (€)',
    specialPriceHelp: 'Optional discounted price (e.g. promotion). If empty, regular price is used.',
    specialPriceValidFrom: 'Special price valid from',
    specialPriceValidTo: 'Special price valid to',
    specialPricePeriodHelp: 'Select the period when special price is active. Outside that period, regular price is used.',
    generateQr: 'Generate QR code',
    qrModalTitle: 'Item QR code',
    specialPriceDateRequired: 'When special price is set, both start and end date are required.',
    specialPriceDateOrder: 'Special price end date must be after start date.',
    status: 'Status',
    available: 'Available',
    moveUp: 'Move up',
    moveDown: 'Move down',
    selectLocation: 'Location for preview and editing',
    locationFallbackGlobal: 'Global menu (fallback)',
    categoryScopeHint: 'Categories are global at establishment level; location here only sets context for preview and navigation.',
    categoryFormLocationContextLabel: 'You are adding/editing category for location:',
    orderFieldsTitle: 'Ordering fields',
    orderFieldsHint: 'Optional fields the customer will choose when ordering later (date, time, picker options, multiplier).',
    orderFieldsEmpty: 'No fields yet. Add a field if you need extra details for this item.',
    orderFieldsAdd: 'Add field',
    orderFieldRemove: 'Remove field',
    orderFieldTitle: 'Field title',
    orderFieldKind: 'Field type',
    fieldKindDate: 'Date',
    fieldKindTime: 'Time',
    fieldKindPicker: 'Picker (options)',
    fieldKindMultiplier: 'Multiplier',
    fieldDateRequired: 'Required for customer',
    fieldTimeMode: 'Mode',
    fieldTimeSingle: 'Single time',
    fieldTimeRange: 'Range (start–end)',
    fieldMultMin: 'Minimum',
    fieldMultMax: 'Maximum',
    fieldMultStep: 'Step',
    fieldPickerSubtype: 'Picker subtype',
    pickerSubtypeOption: 'Options (pricing)',
    pickerSubtypeDuration: 'Reservation duration',
    pickerSubtypeLabel: 'Label + map',
    fieldLabelRepeat: 'Allow multiple selections (repeat)',
    fieldLabelRepeatSection: 'Multiple selection (repeat)',
    fieldLabelMapPreview: 'Zone preview (Google Maps)',
    fieldMapsKeyMissing: 'A Google Maps API key is required for the map. You can still edit GeoJSON manually below.',
    fieldMapsLoadError: 'Google Maps could not load. Check the API key and your connection.',
    fieldLabelMapSection: 'Map and zone (Label)',
    fieldLabelRepeatMax: 'Max repeats',
    fieldLabelGeoJson: 'GeoJSON for map layer',
    fieldLabelGeoInvalid: 'GeoJSON is invalid or cannot be displayed.',
    fieldChoicesHeading: 'Options / rows',
    fieldChoiceAdd: 'Add row',
    fieldChoiceName: 'Name',
    fieldChoiceOp: 'Operator',
    fieldChoiceValue: 'Value',
    fieldReservationMinutes: 'Reservation duration (min)'
  },
  forms: {
    save: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    validationReady: 'All required fields are filled — ready to save.',
    completeRequiredFields: 'Complete required fields to save.',
    submitDisabledHint: 'Fill in all required fields to save.',
    formActions: 'Form actions',
    deleting: 'Deleting...',
    delete: 'Delete',
    category: 'Category',
    selectCategory: 'Select the category this item belongs to',
    deleteConfirmation: 'Delete Confirmation',
    errorSaving: 'An error occurred while saving. Please try again.',
    errorLoading: 'Error loading',
    errorDeleting: 'An error occurred while deleting. Please try again.',
    loading: 'Loading...',
    validationErrors: {
      invalidEmail: 'Please enter a valid email address',
      priceGreaterThanZero: 'Price must be greater than 0',
      nameRequired: 'Please enter a name',
      emailRequired: 'Please enter an email address'
    },
    warningKicker: 'Warning',
    deleteWarningGeneric: 'This action is irreversible and cannot be undone.',
    slugLabel: 'URL slug',
    slugHint: 'This is the clean part of the URL (e.g. zagreb-cafe-bar). Auto-generated from the name; you can customize it. Old links keep working.',
    slugInvalid: 'Slug may contain only lowercase letters, digits and dashes (-), with no spaces or special characters.',
    slugTaken: 'This slug is already taken. Try a different one.'
  },
  analytics: {
    title: 'Analytics',
    totalRevenue: 'Total revenue',
    totalOrders: 'Total orders',
    averageOrder: 'Average order',
    revenueByDay: 'Revenue by day',
    topProducts: 'Top products',
    ordersByStatus: 'Orders by status',
    dateFrom: 'From date',
    dateTo: 'To date',
    applyFilter: 'Apply',
    product: 'Product',
    quantitySold: 'Quantity sold',
    revenue: 'Revenue',
    noData: 'No data for the selected period',
    loading: 'Loading analytics...',
    ordersShort: 'orders',
    status_pending: 'Pending',
    status_confirmed: 'Confirmed',
    status_in_process: 'In progress',
    status_ready: 'Ready',
    status_completed: 'Completed',
    status_rejected: 'Rejected',
    status_canceled: 'Canceled',
    viewMore: 'View more',
    viewLess: 'View less',
    guest: 'Guest',
    loadingOrders: 'Loading orders...',
    noOrdersForStatus: 'No orders for this status in the selected period'
  },
  pagination: {
    prev: 'Previous',
    next: 'Next',
    showing: 'Showing',
    to: 'to',
    of_total: 'of',
    entries: 'entries'
  },
  general: {
    loading: 'Loading...',
    error: 'Error',
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save',
    search: 'Search...',
    viewAll: 'View all',
    noResults: 'No results',
    success: 'Success',
    confirm: 'Confirm',
    metadata: 'Metadata',
    id: 'ID',
    created: 'Created',
    updated: 'Updated',
    create: 'Create',
    edit: 'Edit',
    actions: 'Actions',
    retry: 'Retry',
    delete: 'Delete',
    yes: 'Yes',
    no: 'No',
    uploadError: 'Could not upload image. Check format (JPEG, PNG, GIF, WebP) and size (max 5MB).'
  },
  news: {
    title: 'News',
    manageNews: 'Manage news and announcements for your establishments',
    addNews: 'Add News',
    addNewsTitle: 'New News',
    editNewsTitle: 'Edit News',
    allEstablishments: 'All establishments',
    establishment: 'Establishment',
    selectEstablishment: 'Select establishment',
    basicInfo: 'Basic Information',
    content: 'Content',
    images: 'Images',
    addImage: 'Add Image',
    uploadImage: 'Upload Image',
    startDate: 'Start Date',
    endDate: 'End Date',
    fromDate: 'From',
    untilDate: 'Until',
    validityPeriod: 'Validity Period',
    titlePlaceholder: 'News title',
    contentPlaceholder: 'News content...',
    noNews: 'No news',
    addFirstNews: 'Add the first news for this establishment',
    confirmDelete: 'Are you sure you want to delete this news?',
    notFound: 'News not found',
    uploading: 'Uploading...',
    imagePreview: 'Image preview',
    saveNews: 'Save News'
  },
  profile: {
    title: 'My Profile',
    description: 'View and manage your profile and settings.',
    personalInfo: 'Personal Information',
    personalInfoDesc: 'Your basic account details',
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    city: 'City',
    memberSince: 'Member Since',
    changePassword: 'Change Password',
    changePasswordDesc: 'Update your password for account access',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'At least 6 characters',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Repeat new password',
    passwordMismatch: 'Passwords do not match.',
    passwordSuccess: 'Password changed successfully.',
    savePassword: 'Save Password',
    saving: 'Saving...',
    companyInfo: 'Company Information',
    companyInfoDesc: 'Information about your company',
    companyName: 'Company Name',
    companyAddress: 'Company Address',
    profilePhoto: 'Profile photo',
    profilePhotoDesc: 'Shown in the app once your account is approved.',
    avatarAfterApproval: 'You may upload a profile photo once your registration has been approved by an administrator.',
    uploadAvatar: 'Upload photo',
    removeAvatar: 'Remove photo',
    avatarUploading: 'Uploading...',
    avatarSaved: 'Profile photo saved.',
    avatarRemoved: 'Profile photo removed.',
    projectSettingsTitle: 'Project settings',
    projectSettingsDesc: 'Here you can change only loyalty levels and refer-a-friend settings for the project where you are recorded in the system as the project owner.',
    projectSettingsSelectProject: 'There is no project for which you are the owner, or the context could not be loaded. Please contact an administrator.',
    projectSettingsLoading: 'Loading projects…'
  },
  auth: {
    notAuthenticated: 'You are not logged in. Please log in to continue.',
    notRegistered: 'Not registered yet?',
    registerAsAdmin: 'Register as administrator',
    privacyPolicy: 'Privacy Policy',
    login: {
      subtitle: 'Sign in to administration panel',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      signIn: 'Sign in',
      signingIn: 'Signing in...',
      errorGeneric: 'An error occurred during sign in'
    },
    forgotPassword: {
      link: 'Forgot password?',
      subtitle: 'Enter your email to reset your password',
      emailLabel: 'Email',
      emailPlaceholder: 'you@email.com',
      submit: 'Send reset link',
      sending: 'Sending...',
      success: 'If an account exists with that email, we will send you a reset link. Check your inbox.',
      backToLogin: 'Back to sign in'
    },
    resetPassword: {
      subtitle: 'Set your new password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'At least 6 characters',
      confirmPassword: 'Confirm password',
      confirmPlaceholder: 'Repeat password',
      passwordMismatch: 'Passwords do not match.',
      submit: 'Set password',
      submitting: 'Setting...',
      success: 'Password has been set successfully.',
      backToLogin: 'Sign in',
      invalidLink: 'Reset link is invalid or has expired.',
      requestNew: 'Request a new link.'
    }
  },
  common: {
    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    remove: 'Remove',
    back: 'Back',
    name: 'Name',
    email: 'Email',
    active: 'Active',
    actions: 'Actions',
    errorOccurred: 'An error occurred',
    viewerReadOnlyError: 'This action is not allowed: you have read-only (viewer) access on this project.',
    projectApi: {
      unauthorized: 'You are not signed in. Sign out and sign in again.',
      viewerReadonly: 'You have view-only access on this project — this action is not allowed.',
      forbiddenLocation: 'You do not have access to the selected location in this project.',
      accessCheckFailed: 'Access check failed. Please try again.'
    },
    retry: 'Try again',
    imageTooLarge: 'Image is too large (max 5 MB)',
    successDelete: 'Item successfully deleted',
    successCreate: 'Item successfully created',
    successUpdate: 'Item successfully updated',
    saving: 'Saving...',
    localeHr: 'HR',
    localeEn: 'EN',
    contentLocaleHint: 'Content language for visitors (hr / en).'
  },
  admins: {
    title: 'Administrators',
    suspended: 'Suspended Administrators',
    details: 'Administrator Details',
    pendingApproval: 'Pending Approval',
    approve: 'Approve',
    reject: 'Reject',
    status: 'Status',
    companyInfo: 'Company Information',
    personalInfo: 'Personal Information',
    licenseInfo: 'License Information',
    noPendingAdmins: 'No Pending Requests',
    noPendingAdminsMessage: 'There are no pending administrator approval requests at the moment',
    noActiveAdmins: 'No Active Administrators',
    noActiveAdminsMessage: 'There are currently no active administrators in the system',
    rejected: 'Rejected',
    licenseExpires: 'License Expires',
    licenseActive: 'License Active',
    licenseExpired: 'License Expired',
    licenseSuspended: 'License Suspended',
    licenseInactive: 'License Inactive',
    noLicense: 'No License',
    licenseType: 'License type',
    licenseTypeBasic: 'Basic',
    licenseTypePremium: 'Premium',
    licenseTypeEnterprise: 'Enterprise',
    licenseExpiryDate: 'Expiry date',
    licenseMaxEstablishments: 'Max establishments',
    licenseNote: 'Note',
    licenseStatus: 'License status',
    editLicense: 'Edit license',
    editLicenseSuccess: 'License updated successfully',
    approvalLicenseSection: 'License settings',
    maxEstablishments: 'Maximum Establishments',
    companyName: 'Company Name',
    companyOIB: 'Company OIB',
    approveConfirm: 'Are you sure you want to approve this administrator?',
    rejectConfirm: 'Are you sure you want to reject this administrator?',
    rejectReason: 'Reason for rejection (optional)',
    rejectReasonPlaceholder: 'Provide the reason for rejection. The administrator will receive this text by email.',
    approveSuccess: 'Administrator successfully approved',
    rejectSuccess: 'Administrator successfully rejected',
    search: 'Search Administrators',
    createdAt: 'Created',
    adminActions: 'Actions',
    manageAdmins: 'Manage administrator user accounts',
    projectManagement: 'Project management',
    projectPublicKey: 'Public key',
    selectAdminForProject: 'Select admin',
    projectCreated: 'Project created successfully',
    projectDeleted: 'Project deleted successfully',
    deleteProjectTitle: 'Delete project',
    deleteProjectConfirmBefore: 'Delete project',
    deleteProjectConfirmAfter: ' and all related data (establishments, locations, orders, menus, news, promo codes, complexes, and more)?',
    deleteProjectConfirmIrreversible: 'This action cannot be undone.',
    adminAssignedToProject: 'Admin assigned to project',
    adminRemovedFromProject: 'Admin removed from project',
    noProjectAdmins: 'No admins assigned yet.',
    activeProject: 'Active project',
    copyKey: 'Copy key',
    projectKeyCopied: 'Project key copied',
    selectProjectForApproval: 'Project for approval',
    selectProjectForApprovalPlaceholder: 'Select project before approving',
    createNewProjectOption: 'Create a new project',
    newProjectNamePlaceholder: 'Enter new project name',
    projectSelectionRequired: 'Select a project before approving admin',
    newProjectNameRequired: 'Enter a name for the new project',
    approvalMembershipRole: 'Role on project',
    assignMembershipRole: 'Role when assigning',
    roleProjectOwner: 'Project owner',
    roleContributor: 'Contributor',
    roleViewer: 'Viewer (read-only)',
    navPending: 'Pending approval',
    navDirectory: 'All administrators',
    navProjects: 'Projects & team',
    inviteAdmin: 'Invite admin',
    inviteHint: 'The invited admin receives an email with a link to set a password. License and project are assigned immediately — after accept the account is active.',
    inviteFirstName: 'First name',
    inviteLastName: 'Last name',
    inviteEmail: 'Email',
    inviteFirstNameRequired: 'Enter first name',
    inviteLastNameRequired: 'Enter last name',
    inviteEmailRequired: 'Enter a valid email',
    inviteProjectRequired: 'Select a project before sending the invite',
    sendInvite: 'Send invite',
    inviteSuccess: 'Invite sent to email',
    invited: 'Invited',
    resendInvite: 'Resend',
    resendInviteSuccess: 'Invite email resent',
    revokeInvite: 'Revoke invite',
    revokeInviteConfirm: 'Are you sure you want to revoke this invite?',
    revokeInviteSuccess: 'Invite revoked',
    acceptInvite: {
      subtitle: 'Set a password for the LYLUP admin portal',
      submit: 'Activate account',
      success: 'Account activated',
      successHint: 'You can now sign in to the admin portal.',
      goToLogin: 'Go to login',
      invalidLink: 'Invite link is invalid or missing.',
      error: 'Activation failed. Please try again.',
    },
    projectRolesColumn: 'Projects & roles',
    projectsHelpShort: 'Expand a project for API keys, add members, or change roles in the team table.',
    membersCountSuffix: 'members',
    accessKeysSection: 'Keys & UUID (integrations)',
    addMemberSection: 'Add or update a member',
    addMemberHint: 'If the admin is already on the project, pick a new role and confirm to update — you do not need to add them again.',
    addMemberSubmit: 'Add or save role',
    teamSection: 'Project team',
    roleUpdated: 'Role updated',
    detailNoProjectMemberships: 'Not assigned to any project yet.',
    detailAddToProject: 'Add to project',
    memberRoleLabel: 'Role',
    loyaltyLevelsSection: 'Loyalty levels',
    loyaltyLevelsHint: 'Configure levels and point thresholds for this project.',
    levelName: 'Level name',
    levelNamePlaceholder: 'e.g. Platinum',
    minPoints: 'Min. points',
    addLevel: 'Add level',
    loyaltyLevelsSaved: 'Levels saved successfully',
    levelNameRequired: 'All levels must have a name',
    levelNameDuplicate: 'Level names must be unique',
    pointsScopeSection: 'Points collection mode',
    pointsScopeHint: 'Choose how points are tracked — per establishment/complex or shared across the entire project.',
    pointsScopeEstablishment: 'Per establishment / complex (separate balances)',
    pointsScopeProject: 'Per project (single shared balance)',
    pointsScopeSaved: 'Points collection mode saved',
    pointsScopeEstablishmentDescription: 'Each user has separate points per establishment (or per complex if the complex is set to shared balance). Points can only be spent where they were earned.',
    pointsScopeProjectDescription: 'Each user has a single shared balance across the entire project. Points are earned and spent at any establishment within the project.',
    pointsProgramSection: 'Loyalty program',
    pointsProgramHint: 'Choose one of 4 programs for the whole project. Establishments inherit this setting; per-venue rates still apply.',
    pointsProgramSaved: 'Loyalty program saved',
    pointsProgramOrderEstablishment: 'Order + per establishment',
    pointsProgramOrderProject: 'Order + per project',
    pointsProgramCardEstablishment: 'Card + per establishment',
    pointsProgramCardProject: 'Card + per project',
    pointsProgramOrderEstablishmentDescription: 'Points are awarded automatically after an order. Each user has a separate balance per establishment.',
    pointsProgramOrderProjectDescription: 'Points are awarded automatically after an order. Each user has one shared balance across the project.',
    pointsProgramCardEstablishmentDescription: 'Points are awarded by card scan or manual entry. Each user has a separate balance per establishment.',
    pointsProgramCardProjectDescription: 'Points are awarded by card scan or manual entry. Each user has one shared balance across the project.',
    referralSection: 'Refer a friend',
    referralHint: 'Enable referrals for this project and set how many points the referrer gets after a friend registers with their code. Optionally reward the new user (welcome bonus).',
    referralEnabled: 'Enable friend referrals',
    referralReferrerPoints: 'Points for referrer',
    referralRefereePoints: 'Points for new user (welcome)',
    referralSaved: 'Referral settings saved',
    referralReferrerMin: 'When referrals are enabled, referrer points must be at least 1.',
    onlinePaymentsSection: 'Online payments',
    onlinePaymentsHint: 'Choose the only payment provider establishments in this project can use. Monri and Corvus Pay: each venue connects its own merchant account. Stripe: venues onboard as connected accounts on your Stripe account.',
    onlinePaymentsChooseHelp: 'One provider is active at a time. You can switch anytime; previously saved credentials stay on file and apply again if you switch back.',
    onlinePaymentsSaved: 'Online payment provider saved',
    onlinePaymentsSaveFailed: 'Could not save the payment provider',
    onlinePaymentsSave: 'Save payment provider',
    gatewayCredentialsSection: 'Merchant credentials (per establishment)',
    gatewayCredentialsHint:
      'Selecting Monri or Corvus Pay enables that provider for every establishment in this project. Each venue then enters its own merchant account on Establishment → Online payments.',
    gatewayCredentialsEstablishmentNote:
      'These fields are not entered here. Open each establishment’s Online payments tab to connect that venue’s merchant account.',
    stripeConnectSection: 'Connect your Stripe account',
    stripeConnectHint: 'Sandbox or live restricted key (rk_) plus publishable key (pk_). Establishments then complete Connect KYC on this account.',
    stripeSandbox: 'Sandbox (test)',
    stripeLive: 'Live',
    stripePublishableKey: 'Publishable key',
    stripeRestrictedKey: 'Restricted key',
    stripeRestrictedKeyHelp: 'Use a restricted key (rk_test_ / rk_live_). It is stored encrypted and never shown again.',
    stripePaymentWebhookSecret: 'Payments webhook secret (optional)',
    stripeConnectWebhookSecret: 'Connect webhook secret (optional)',
    stripePaymentWebhookUrl: 'Payments webhook URL',
    stripeConnectWebhookUrl: 'Connect webhook URL',
    stripeWebhookHelp: 'Paste these URLs in your Stripe Dashboard webhooks, then save the signing secrets here.',
    stripeKeysNeverEchoed: 'Restricted keys and webhook secrets are never returned after save.',
    stripeConnectSubmit: 'Test connection and save',
    stripeConnectUpdate: 'Test and update',
    stripeConnectSaved: 'Stripe account connected',
    stripeConnectFailed: 'Could not connect Stripe',
    stripeConnected: 'Connected',
    stripeNotConnected: 'Not connected',
  },
  rewards: {
    title: 'Manage Rewards',
    pageSubtitle: 'Create and manage rewards for all loyalty program levels',
    descriptionLabel: 'Description',
    points: 'points',
    requiredLevel: 'Required level',
    level: 'Level',
    createReward: 'Add Reward',
    createTitle: 'Create New Reward',
    editTitle: 'Edit Reward',
    searchPlaceholder: 'Search rewards...',
    allStatus: 'All Statuses',
    activeStatus: 'Active',
    inactiveStatus: 'Inactive',
    allLevels: 'All Levels',
    levelBronze: 'Bronze',
    levelSilver: 'Silver',
    levelGold: 'Gold',
    levelRemoved: 'removed',
    forAllLevels: 'For All Levels',
    noRewardsFound: 'No Rewards Found',
    noRewardsFoundMessage: 'No rewards were found matching your search criteria.',
    name: 'Name',
    namePlaceholder: 'Enter reward name',
    descriptionPlaceholder: 'Describe the reward and what the user gets',
    pointsRequired: 'Points Required',
    status: 'Status',
    createdAt: 'Created Date',
    confirmDeleteMessage: 'Are you sure you want to delete this reward?',
    discountValue: 'Discount Percentage',
    discountValueFixed: 'Discount amount (€)',
    rewardType: 'Reward type',
    selectRewardType: 'Select reward type',
    typeCartPercent: 'Cart discount (%)',
    typeCartFixed: 'Fixed cart discount (€)',
    typeItemPercent: 'Item discount (%)',
    typeFreeItem: 'Free item',
    typeInStore: 'In-store only',
    menuItem: 'Menu item',
    selectMenuItem: 'Select menu item',
    menuItemRequired: 'Select a menu item for this reward type',
    menuItemLoading: 'Loading menu items…',
    menuItemEmpty: 'No menu items available for this establishment',
    valueRequired: 'Value is required',
    valuePercentInvalid: 'Percentage must be between 0 and 100',
    valueFixedInvalid: 'Amount must be greater than 0',
    establishment: 'Establishment',
    selectEstablishment: 'Select establishment',
    selectEstablishmentFirst: 'Select establishment first',
    selectLevel: 'Select level',
    selectLevelRequired: 'Please select a level.',
    validFrom: 'Valid From',
    validUntil: 'Valid Until',
    noStartDate: 'No start date',
    noEndDate: 'No end date',
    basicInfo: 'Basic Information',
    rewardRequirements: 'Reward Requirements',
    activateReward: 'Activate Reward',
    deactivateReward: 'Deactivate Reward',
    saveReward: 'Save Reward',
    nameLocaleRequired: 'Enter the name in Croatian or English.',
    descriptionLocaleRequired: 'Enter the description in Croatian or English.',
    nameLocaleTooLong: 'The name cannot exceed 100 characters per language.'
  },
  tables: {
    manageTables: 'Manage Tables',
    backToLocation: 'Back to Location',
    addTable: 'Add Table',
    editTable: 'Edit Table',
    tableName: 'Table Name',
    tableNumber: 'Table Number',
    capacity: 'Capacity',
    capacityPlaceholder: 'Enter table capacity',
    noTables: 'No Tables',
    addTablePrompt: 'Add your first table for this location',
    notSpecified: 'Not specified',
    batchAddTables: 'Add Multiple Tables',
    namePrefix: 'Name Prefix',
    namePrefixPlaceholder: 'e.g. Table',
    namePrefixHelp: 'This text will be added before the table number',
    startNumber: 'Start Number',
    startNumberPlaceholder: 'e.g. 1',
    endNumber: 'End Number',
    endNumberPlaceholder: 'e.g. 10',
    preview: 'Preview',
    createTables: 'Create Tables',
    generateQRCodes: 'Generate QR Codes',
    generateQRBatch: 'Generate QR Codes for Tables',
    qrCodeFor: 'QR Code for',
    selectTables: 'Select Tables',
    downloadQR: 'Download QR Code',
    printQR: 'Print QR Code',
    downloadAllQR: 'Download All QR Codes',
    printAllQR: 'Print All QR Codes',
    confirmDelete: 'Confirm Delete',
    deleteConfirmMessage: 'Are you sure you want to delete table',
    deleteConfirmWarning: 'This action will permanently remove the table and its QR codes from the system.',
    errorDeletingTable: 'Error deleting table',
    errorFetchingTables: 'Error fetching tables',
    errorGeneratingQR: 'Error generating QR code',
    errorGeneratingQRCodes: 'Error generating QR codes',
    errorGeneratingZIP: 'Error generating ZIP archive',
    errorSavingTable: 'Error saving table',
    errorCreatingTables: 'Error creating tables',
    invalidRangeError: 'Invalid number range. Start number must be less than end number and you can create a maximum of 100 tables at once.',
    locationName: 'Location',
    qrCodesGenerated: 'QR codes generated',
    settings: 'Settings',
    enterValidRange: 'Enter a valid range',
    allTables: 'All tables',
    selectTablesToGenerate: 'Select tables to generate',
    selectAll: 'Select all',
    deselectAll: 'Deselect all'
  },
  employees: {
    title: 'Employees',
    manageEmployees: 'Manage employees by location — they see and confirm orders for their location in the app.',
    createNew: 'Add employee',
    inviteEmployee: 'Invite employee',
    inviteHint: 'The employee will receive an email with a link to set their password, then sign in to the LYLUP mobile app.',
    inviteSuccess: 'Invite sent to email',
    sendInvite: 'Send invite',
    resendInvite: 'Resend invite',
    resendInviteSuccess: 'Invite resent',
    status: 'Status',
    statusActive: 'Active',
    statusPending: 'Pending activation',
    noEmployees: 'No employees',
    noEmployeesMessage: 'No employees have been added yet. Invite an employee using the button above.',
    employeeDetails: 'Employee details',
    newEmployee: 'New employee',
    editEmployee: 'Edit employee',
    name: 'Full name',
    email: 'Email',
    password: 'Password',
    location: 'Location',
    created: 'Created',
    confirmDelete: 'Are you sure you want to delete this employee',
    deleteBlockedLastActive: 'You cannot delete the only active employee at this location',
    deleteLastActiveWarning: 'After deletion, nobody in the app would see orders for this location. Invite another employee first.',
    basicInfo: 'Basic information',
    selectLocation: 'Select location',
    noLocations: 'No locations available',
    createLocationFirst: 'Create a location first to assign an employee.',
    backToEmployees: 'Back to employees',
    saveEmployee: 'Save employee',
    passwordInfo: 'Password must be at least 6 characters',
    saveSuccess: 'Employee saved successfully',
    deleteSuccess: 'Employee deleted successfully',
    search: 'Search employees...',
    filterByLocation: 'All locations',
    acceptInvite: {
      subtitle: 'Set a password for your employee account',
      submit: 'Activate account',
      success: 'Account activated.',
      successHint: 'Sign in to the LYLUP mobile app as an employee.',
      invalidLink: 'Invite link is invalid or expired.',
      error: 'Could not activate account.'
    }
  },
  complexes: {
    title: 'Complexes',
    description: 'Manage complexes (groups of establishments)',
    noComplexes: 'No complexes yet. Add your first complex.',
    add: 'New Complex',
    edit: 'Edit Complex',
    name: 'Name',
    pointsScope: 'Points Collection',
    pointsScopeEstablishment: 'Per Establishment',
    pointsScopeComplex: 'Shared Across Complex',
    pointsScopeEstablishmentDescription: 'User has separate points for each establishment in the complex',
    pointsScopeComplexDescription: 'All establishments in the complex share one common points balance',
    establishments: 'Establishments in Complex',
    noEstablishments: 'No establishments added',
    confirmDelete: 'Are you sure you want to delete this complex?',
    saveComplex: 'Save Complex',
    backToComplexes: 'Back to Complexes'
  },
  publicPages: {
    nav: {
      privacy: 'Privacy Policy',
      support: 'Support',
      marketing: 'About Lylup',
      deleteAccount: 'Delete account'
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: July 24, 2026',
      intro:
        'This Privacy Policy describes how we collect, use, and protect your information when you use the Lylup mobile application.',
      cameraTitle: 'Camera usage',
      cameraIntro: 'Our app uses your device’s camera for the following purposes:',
      cameraScanTitle: 'QR code and barcode scanning:',
      cameraScanBody:
        'We use the camera to scan QR codes and barcodes so you can open digital menus, identify loyalty activity, and redeem rewards. The camera feed is processed on your device — we do not store or transmit camera images for scanning.',
      cameraPhotoTitle: 'Photo capture:',
      cameraPhotoBody:
        'The app may use the camera to capture photos (for example a profile picture) only when you explicitly start that action. Photos are stored according to your consent and account settings.',
      cameraNote:
        'Camera access is optional. If you deny permission, features that require scanning or photo capture will not be available.',
      collectTitle: 'Information we collect',
      collectBody:
        'We collect information you provide when registering (name, email, phone and related profile fields), loyalty activity (points, rewards, transactions), order details when you place orders, and device information needed for push notifications and app stability.',
      useTitle: 'How we use your information',
      useBody:
        'We use your information to operate the loyalty programme, process rewards and orders, send relevant notifications, improve our services, provide support, and comply with legal obligations.',
      shareTitle: 'Data sharing',
      shareBody:
        'We do not sell your personal data. We may share information with participating venues (for loyalty and orders) and service providers who assist our operations, under confidentiality obligations, only as needed to deliver the service.',
      securityTitle: 'Data security',
      securityBody:
        'We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, or loss.',
      rightsTitle: 'Your rights',
      rightsBody:
        'Depending on applicable law, you may request access, correction, deletion, restriction, objection or portability of your personal data, and withdraw consent where processing is based on consent. You can request account deletion via the Delete account page or by contacting us.',
      contactTitle: 'Contact',
      contactBody:
        'For questions about this Privacy Policy or your data, contact us at info@gauss.hr or through the Support page.'
    },
    support: {
      title: 'Support',
      intro:
        'Need help with Lylup? Contact our team and we will help with your account, points, orders, or privacy requests.',
      howTitle: 'How to reach us',
      howEmail: 'Email: info@gauss.hr',
      howPhone: 'Phone: +385 95 342 9600',
      howApp: 'In the app: use Account for profile, points, and order history.',
      topicsTitle: 'What we can help with',
      topicAccount: 'Sign-in, registration, and profile updates',
      topicPoints: 'Points balance, rewards, and referral questions',
      topicOrders: 'Orders, delivery/pickup, and payment status',
      topicPrivacy: 'Privacy requests and account deletion',
      cta: 'Write to us and include the email used in your Lylup account:'
    },
    marketing: {
      title: 'Lylup',
      intro:
        'Lylup is a mobile loyalty app for collecting points, discovering partner offers, ordering from participating venues, and unlocking rewards.',
      featuresTitle: 'What you can do',
      featurePoints: 'Collect and track loyalty points across partner locations',
      featureOrders: 'Order for pickup or delivery where available',
      featureOffers: 'Browse menus, promotions, and news from your favourite venues',
      featureScan: 'Scan codes for faster loyalty and menu access',
      featureReferral: 'Invite friends and earn referral rewards where enabled',
      whoTitle: 'Who it is for',
      whoBody:
        'Lylup is built for guests of restaurants and hospitality venues that run a digital loyalty programme. The app is developed by Gauss d.o.o.',
      cta: 'Learn more about Gauss:'
    },
    deleteAccount: {
      title: 'Delete your Lylup account',
      intro:
        'You can request permanent deletion of your Lylup account and associated personal data. After deletion you will lose access to points, order history, and saved profile information.',
      stepsTitle: 'How to request deletion',
      step1: 'Send an email to info@gauss.hr from the address linked to your Lylup account.',
      step2: 'Use the subject “Lylup account deletion request” and include your full name and phone number registered in the app.',
      step3: 'We will confirm the request and delete the account, usually within 30 days.',
      whatTitle: 'What gets deleted',
      whatBody:
        'We delete or anonymise account profile data, loyalty balances tied to your user, and personal order history that is no longer required for the service.',
      retainTitle: 'What we may retain',
      retainBody:
        'We may retain limited records when the law requires it (for example tax or payment records) or when needed to prevent abuse, for the minimum period required.',
      cta: 'Request account deletion:',
      mailSubject: 'Lylup account deletion request'
    }
  }
}
